import { render, staticRenderFns } from "./ModuleDashboardComponent.vue?vue&type=template&id=3c61d605&scoped=true"
import script from "./ModuleDashboardComponent.vue?vue&type=script&lang=js"
export * from "./ModuleDashboardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c61d605",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c61d605')) {
      api.createRecord('3c61d605', component.options)
    } else {
      api.reload('3c61d605', component.options)
    }
    module.hot.accept("./ModuleDashboardComponent.vue?vue&type=template&id=3c61d605&scoped=true", function () {
      api.rerender('3c61d605', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModuleDashboardComponent.vue"
export default component.exports